/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { ParameterValue } from "../simple-function-action-editor.component";
import { SimpleSuccessErrorDialogComponent } from "app/components/simple-success-error-dialog-box/simple-success-error-dialog-box.component";

@Component({
  selector: 'app-function-parameter-editor-number',
  templateUrl: './number-function-parameter-editor.component.html'
})
export class NumberFunctionParameterEditorComponent {

  @Input()
  parameterValue: ParameterValue;

  @Output()
  valueChange = new EventEmitter<void>();

  get numberValue(): string {
    return this.parameterValue == null? null : this.parameterValue.mValue;
  }
  set numberValue(value: string) {
    if (this.parameterValue != null) {
      this.parameterValue.mValue = value;
      this.valueChange.emit();
    }
  }

  constructor(
  ) {}

}
